import script from "./vipTableView.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipTableView.vue?vue&type=script&setup=true&lang=ts"

import "./vipTableView.vue?vue&type=style&index=0&id=23b7a9bd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b7a9bd"]])

export default __exports__